import * as Sentry from '@sentry/react';
import { isExpectedApiFailure } from '@wundo/client/isExpectedApiFailure.ts';

/**
 * Report something that went wrong where the screen already handled it.
 *
 * A failure a component catches and turns into a sentence never reaches the
 * error boundary, and so never reaches Sentry on its own — which is exactly
 * backwards for the failures that matter most: an upload that will not finish
 * and a Slack that will not answer are both handled gracefully, and both are
 * things we have to be told about.
 *
 * An expected API failure — a session that changed underneath the tab, a
 * dropped connection — is the screen's to handle, not ours to be told about.
 *
 * `context` is whatever the screen knows that the stack does not: which
 * document, which routine, which row of the import it was on.
 */
export function reportError(error: unknown, context: Record<string, unknown>): void {
  if (isExpectedApiFailure(error)) return;

  Sentry.captureException(error, { extra: context });
}
